export const hostLocation = window.location.host;
const protocol = window.location.protocol;
export const baseEndpoint = `${protocol}//${hostLocation}`;

export const subdomain = window.location.host.split('.')[2]
  ? window.location.host.split('.')[0]
  : false;

export const redirectDomain = `${protocol}//www.${hostLocation}`;

export const AI_ASK_ENDPOINT = `${baseEndpoint}/api/v1/ask`;
export const AI_RATE_ENDPOINT = `${baseEndpoint}/api/v1/rate`;
export const CURRENT_SUBDOMAIN = window.location.hostname.split('.')[0];
export const LOGIN_ENDPOINT = `${baseEndpoint}/api/v1/auth/login`;
export const TOKEN_EXCHANGE_ENDPOINT = `${baseEndpoint}/api/v1/auth/token`;
export const VERIFICATION_EMAIL_ENDPOINT = `${baseEndpoint}/api/v1/auth/email-verification`;
export const PASSWORD_RESET_ENDPOINT = `${baseEndpoint}/api/v1/auth/password-reset-email`;
export const TENANT_ENDPOINT = `${baseEndpoint}/api/v1/tenants`;
export const WORK_ORDERS_ENDPOINT = `${baseEndpoint}/api/v1/workOrders`;
export const BULK_WORK_ORDERS_ENDPOINT = `${baseEndpoint}/api/v1/bulk/workOrders`;
export const MAP_ENDPOINT = `${baseEndpoint}/api/v1/map`;
export const SEARCH_ENDPOINT = `${baseEndpoint}/api/v1/search`;
export const REGISTRATION_ENDPOINT = `${baseEndpoint}/api/v1/registration`;
export const USER_PROFILE_ENDPOINT = `${baseEndpoint}/api/v1/profile`;
export const USERS_ENDPOINT = `${baseEndpoint}/api/v1/users`;
export const FORM_TEMPLATES_ENDPOINT = `${baseEndpoint}/api/v1/formTemplates`;
export const FORM_INSTANCES_ENDPOINT = `${baseEndpoint}/api/v1/formInstances`;
export const BULK_EDIT_ASSETS_TEMPLATE_ENDPOINT = `${baseEndpoint}/api/v1/inventory/bulkEdit/assets/template`;
export const CATEGORIES_ENDPOINT = `${baseEndpoint}/api/v1/inventory/categories`;
export const INVENTORY_BULK_ASSETS_ENDPOINT = `${baseEndpoint}/api/v1/inventory/bulk/assets`;
export const INVENTORY_ASSETS_ENDPOINT = `${baseEndpoint}/api/v1/inventory/assets`;
export const INVENTORY_ASSETS_FILTER_ENDPOINT = `${baseEndpoint}/api/v1/inventory/assets-filter`;
export const INVENTORY_MUTCD_ENDPOINT = `${baseEndpoint}/api/v1/inventory/mutcd`;
export const INVENTORY_SCHEMAS_ENDPOINT = `${baseEndpoint}/api/v1/schemas`;
export const INVENTORY_REPORT_ENDPOINT = `${baseEndpoint}/api/v1/inventory/report`;
export const INVENTORY_EXPORT_ENDPOINT = `${baseEndpoint}/api/v1/inventory/assets/exportTemplates`;
export const POOL_ATTRIBUTES_ENDPOINT = `${baseEndpoint}/api/v1/poolAttributes`;
export const FILES_ENDPOINT = `${baseEndpoint}/api/v1/files`;
export const FILE_TYPES_ENDPOINT = `${baseEndpoint}/api/v1/files/types`;
export const CHART_EXPORT_ENDPOINT = `${baseEndpoint}/api/v1/chart`;
export const FILES_ARCHIVE_ENDPOINT = `${baseEndpoint}/api/v1/files-archive`;
export const FILES_CSV_UPLOAD_ENDPOINT = `${baseEndpoint}/api/v1/files-csv-upload`;
export const FILES_INVENTORY_CSV_DOWNLOAD_ENDPOINT = `${baseEndpoint}/api/v1/files-csv-download/inventory`;
export const FILES_WORK_CSV_DOWNLOAD_ENDPOINT = `${baseEndpoint}/api/v1/files-csv-download/work`;
export const FILES_USERS_CSV_DOWNLOAD_ENDPOINT = `${baseEndpoint}/api/v1/files-csv-download/users`;
export const MEDIA_ENDPOINT = `${baseEndpoint}/api/v1/media`;
export const HISTORY_ENDPOINT = `${baseEndpoint}/api/v1/history`;
export const WORK_TEMPLATES_ENDPOINT = `${baseEndpoint}/api/v1/workTemplates`;
export const TASK_TEMPLATES_ENDPOINT = `${baseEndpoint}/api/v1/taskTemplates`;
export const WORK_TEMPLATES_FOLDER_TREE_ENDPOINT = `${baseEndpoint}/api/v1/workTemplateFolders/tree`;
export const WORK_TEMPLATES_FOLDER_ENDPOINT = `${baseEndpoint}/api/v1/workTemplateFolders`;
export const BASE_API_ENDPOINT = `${baseEndpoint}/api/v1`;
export const GRAPHQL_ENDPOINT = `${baseEndpoint}/graphql`;
export const CHAT_ENDPOINT = `${baseEndpoint}/api/v1/chat`;
export const REALTIME_ENDPOINT = `${protocol === 'https:' ? 'wss:' : 'ws:'}//${hostLocation}/rt/v1/${CURRENT_SUBDOMAIN}/connect/websocket`;

export type BudgetTemplateType = 'budgetItems' | 'authorizedBudget';

const DOWNLOAD_BUDGET_CSV_ENDPOINT = `${baseEndpoint}/api/v1/files-csv-download/budget`;
const DOWNLOAD_AUTH_BUDGET_CSV_ENDPOINT = `${baseEndpoint}/api/v1/files-csv-download/authorizedBudget`;

const DOWNLOAD_TEMPLATE_BUDGET_CSV_ENDPOINT = `${baseEndpoint}/api/v1/files-csv-download/budgetTemplate`;
const DOWNLOAD_TEMPLATE_AUTH_BUDGET_CSV_ENDPOINT = `${baseEndpoint}/api/v1/files-csv-download/authorizedBudgetTemplate`;

const UPLOAD_BUDGET_CSV_ENDPOINT = `${baseEndpoint}/api/v1/files-csv-upload/budget`;
const UPLOAD_AUTH_BUDGET_CSV_ENDPOINT = `${baseEndpoint}/api/v1/files-csv-upload/authorizedBudget`;

export const getDownloadBudgetEndpoint = (type: BudgetTemplateType) =>
  type === 'authorizedBudget'
    ? DOWNLOAD_AUTH_BUDGET_CSV_ENDPOINT
    : DOWNLOAD_BUDGET_CSV_ENDPOINT;

export const getBudgetTemplateEndpoint = (type: BudgetTemplateType) =>
  type === 'authorizedBudget'
    ? DOWNLOAD_TEMPLATE_AUTH_BUDGET_CSV_ENDPOINT
    : DOWNLOAD_TEMPLATE_BUDGET_CSV_ENDPOINT;

export const getUploadBudgetEndpoint = (type: BudgetTemplateType) =>
  type === 'authorizedBudget'
    ? UPLOAD_AUTH_BUDGET_CSV_ENDPOINT
    : UPLOAD_BUDGET_CSV_ENDPOINT;

export const getWorkOrderTasksEndpoint = workOrderId =>
  `${WORK_ORDERS_ENDPOINT}/${workOrderId}/tasks`;

export const getFormInstanceMediaEndpoint = (formInstanceId, subjectId) =>
  `${FORM_INSTANCES_ENDPOINT}/${formInstanceId}/subject/${subjectId}/media`;

export const getFormInstanceFhwaEndpoint = (formInstanceId, pageId, fieldId) =>
  `${FORM_INSTANCES_ENDPOINT}/${formInstanceId}/page/${pageId}/fhwa/${fieldId}/asset`;

export const getFormInstanceCiEndpoint = (
  formInstanceId: string,
  pageId: string,
  fieldId: string,
) =>
  `${FORM_INSTANCES_ENDPOINT}/${formInstanceId}/page/${pageId}/ci/${fieldId}`;

export const getFormInstancePciEndpoint = (
  formInstanceId: string,
  pageId: string,
  fieldId: string,
) =>
  `${FORM_INSTANCES_ENDPOINT}/${formInstanceId}/page/${pageId}/pci/${fieldId}`;

export const getFormInstanceAttributeEndpoint = (
  formInstanceId,
  pageId,
  fieldId,
  assetId,
) =>
  `${FORM_INSTANCES_ENDPOINT}/${formInstanceId}/page/${pageId}/field/${fieldId}/asset/${assetId}/attribute`;

export const getFormInstanceFieldEndpoint = (formInstanceId, pageId) =>
  `${FORM_INSTANCES_ENDPOINT}/${formInstanceId}/page/${pageId}/field`;

export const getWorkflowEndpoint = (workflowId: string) =>
  `${baseEndpoint}/api/v1/workflows/${workflowId}`;

export const getWorkflowCompleteEndpoint = (workflowId: string) =>
  `${getWorkflowEndpoint(workflowId)}/complete`;
